import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { TicketApp } from './TicketApp';
import { aplicarTemaDesdeStorage } from './helpers/theme';

// Aplica el tema de marca guardado lo antes posible (evita parpadeo de color).
aplicarTemaDesdeStorage();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <TicketApp />
);

